// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --disp-primary: #1a56db;
  --disp-primary-dark: #0f2d5e;
  --disp-success: #057a55;
  --disp-error: #dc2626;
  --disp-text: #0f172a;
  --disp-text-secondary: #64748b;
  --disp-border: #e2e8f0;
  --disp-bg: #fff;
  --disp-bg-secondary: #f8fafc;
  --disp-font-sans: 'DM Sans', sans-serif;
  --disp-font-mono: 'DM Mono', monospace;

  --serie-1: #3b82f6;
  --serie-2: #8b5cf6;
  --serie-3: #ec4899;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.disp-fade-in {
  animation: fadeIn 0.4s ease-out forwards;
}

.disp-fade-in-delay-1 {
  animation: fadeIn 0.4s ease-out 0.1s forwards;
  opacity: 0;
}

.disp-fade-in-delay-2 {
  animation: fadeIn 0.4s ease-out 0.2s forwards;
  opacity: 0;
}

/* Base layout */
.disp-container {
  font-family: var(--disp-font-sans);
  background-color: var(--disp-bg-secondary);
  color: var(--disp-text);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Header */
.disp-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  background-color: var(--disp-bg);
  border-bottom: 1px solid var(--disp-border);
  z-index: 10;
}

.disp-header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.disp-btn-primary {
  background-color: var(--disp-primary);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(26, 86, 219, 0.1);
}

.disp-btn-primary:hover {
  background-color: var(--disp-primary-dark);
  box-shadow: 0 4px 6px -1px rgba(26, 86, 219, 0.2);
  transform: translateY(-1px);
}

/* Main Layout */
.disp-main-layout {
  display: flex;
  flex: 1 1;
  overflow: hidden;
}

/* Sidebar */
.disp-sidebar {
  width: 180px;
  min-width: 180px;
  background-color: var(--disp-bg);
  border-right: 1px solid var(--disp-border);
  padding: 20px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
}

.disp-sidebar-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--disp-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 0 8px;
  margin-bottom: 8px;
}

.disp-metric-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.disp-metric-item:hover {
  background-color: var(--disp-bg-secondary);
}

.disp-metric-item input[type="radio"] {
  accent-color: var(--disp-primary);
  width: 18px;
  height: 18px;
  cursor: pointer;
  margin: 0;
}

.disp-metric-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--disp-text);
}

/* Content Area */
.disp-content {
  flex: 1 1;
  padding: 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Filters Section */
.disp-filters-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.disp-filters-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.disp-btn-add {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: var(--disp-primary);
  color: white;
  border: none;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(26, 86, 219, 0.25);
  line-height: 1;
}

.disp-btn-add:hover {
  background-color: var(--disp-primary-dark);
  transform: scale(1.05);
}

/* Grid Table for Series */
.disp-grid-table {
  background-color: var(--disp-bg);
  border-radius: 12px;
  border: 1px solid var(--disp-border);
  overflow: visible;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.disp-grid-header {
  display: grid;
  grid-template-columns: 100px minmax(140px, 1fr) minmax(160px, 1.2fr) minmax(140px, 1fr) minmax(140px, 1fr) 80px;
  gap: 16px;
  padding: 12px 20px;
  background-color: var(--disp-primary-dark);
  align-items: center;
  border-top-left-radius: 11px;
  border-top-right-radius: 11px;
}

.disp-grid-header > div {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  overflow: visible;
}

.disp-grid-row {
  display: grid;
  grid-template-columns: 100px minmax(140px, 1fr) minmax(160px, 1.2fr) minmax(140px, 1fr) minmax(140px, 1fr) 80px;
  gap: 16px;
  padding: 12px 20px;
  align-items: center;
  border-bottom: 1px solid var(--disp-border);
  transition: background-color 0.2s;
  overflow: visible;
}

.disp-menu-search-container {
  grid-column: span 4;
  width: 100%;
  min-width: 0;
}

.compact-menu-disp {
  display: grid !important;
  grid-template-columns: minmax(140px, 1fr) minmax(160px, 1.2fr) minmax(140px, 1fr) minmax(140px, 1fr) !important;
  gap: 16px !important;
  width: 100% !important;
  min-width: 0 !important;
}

.compact-option-large {
  width: 100%;
  min-width: 0;
  position: relative;
}

.compact-option-large .user-box-disp,
.compact-option-large .react-select-container-admin-gs,
.compact-option-large .react-select-admin-gs__control {
  white-space: nowrap !important;
  flex-wrap: nowrap !important;
  min-width: 0 !important;
  width: 100% !important;
}

.user-box-disp {
  width: 100%;
}

.disp-grid-row:hover {
  background-color: var(--disp-bg-secondary);
}

.disp-grid-row:nth-child(even) {
  background-color: #fafafa;
}

.disp-grid-row:nth-child(even):hover {
  background-color: #f1f5f9;
}

.disp-grid-row:last-child {
  border-bottom: none;
}

.disp-serie-name {
  display: flex;
  align-items: center;
  gap: 10px;
  overflow: visible;

  font-size: 13px;
  font-weight: 600;
}

.disp-bullet {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.disp-menu-search-container {
  grid-column: span 4;
  width: 100%;
}

.disp-menu-search-container>div {
  display: grid !important;
  grid-template-columns: 1fr 1fr 1fr 1fr !important;
  gap: 12px !important;
  width: 100% !important;
}

.disp-btn-icon {
  background: transparent;
  border: 1px solid transparent;
  color: var(--disp-text-secondary);
  border-radius: 6px;
  padding: 8px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.disp-btn-icon:hover {
  background-color: var(--disp-bg-secondary);
  color: var(--disp-text);
  border-color: var(--disp-border);
}

.disp-btn-icon.danger {
  color: var(--disp-error);
}

.disp-btn-icon.danger:hover {
  background-color: #fef2f2;
  border-color: #fecaca;
  color: var(--disp-error);
}

/* Card containing chart */
.disp-card {
  background-color: var(--disp-bg);
  border-radius: 12px;
  border: 1px solid var(--disp-border);
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.disp-card-header {
  padding: 12px 20px;
  border-bottom: 1px solid var(--disp-border);
  background-color: var(--disp-bg-secondary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px 12px 0 0;
  min-height: 56px;
}

.disp-checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 8px;
  transition: background-color 0.2s;
  border: 1px solid var(--disp-border);
  background-color: var(--disp-bg);
}

.disp-checkbox-wrapper:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
}

.disp-checkbox-wrapper input[type="checkbox"] {
  accent-color: var(--disp-primary);
  width: 18px;
  height: 18px;
  cursor: pointer;
  margin: 0;
}

.disp-checkbox-wrapper span {
  font-size: 13px;
  font-weight: 500;
  -webkit-user-select: none;
          user-select: none;
}

.disp-chart-area {
  height: 400px;
  padding: 20px;
  position: relative;
}

.disp-chart-footer {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 20px;
  border-top: 1px solid var(--disp-border);
  background-color: #fafafa;
  border-radius: 0 0 12px 12px;
}

.disp-stat-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.disp-stat-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--disp-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.disp-stat-values {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.disp-stat-value {
  font-size: 14px;
  font-family: var(--disp-font-mono);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.disp-mono {
  font-family: var(--disp-font-mono);
}

/* Results Table */
.disp-results-table {
  background-color: var(--disp-bg);
  border-radius: 12px;
  border: 1px solid var(--disp-border);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.disp-results-header {
  display: grid;
  grid-template-columns: 1.5fr 1.5fr 1fr 1fr 1fr;
  gap: 16px;
  padding: 14px 20px;
  background-color: var(--disp-primary-dark);
  align-items: center;
}

.disp-results-header>div {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.disp-results-row {
  display: grid;
  grid-template-columns: 1.5fr 1.5fr 1fr 1fr 1fr;
  gap: 16px;
  padding: 14px 20px;
  align-items: center;
  border-bottom: 1px solid var(--disp-border);
  transition: background-color 0.2s;
}

.disp-results-row:hover {
  background-color: var(--disp-bg-secondary);
}

.disp-results-row:last-child {
  border-bottom: none;
}

.disp-results-val {
  font-family: var(--disp-font-mono);
  font-size: 14px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/reportes-components/styles/disponibilidad.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,4BAA4B;EAC5B,uCAAuC;EACvC,sCAAsC;;EAEtC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,iDAAiD;EACjD,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oCAAoC;EACpC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,+GAA+G;EAC/G,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+GAA+G;EAC/G,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,+GAA+G;EAC/G,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;EAGE,8BAA8B;EAC9B,4BAA4B;EAC5B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;;EAEjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,iDAAiD;EACjD,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,wCAAwC;EACxC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[":root {\n  --disp-primary: #1a56db;\n  --disp-primary-dark: #0f2d5e;\n  --disp-success: #057a55;\n  --disp-error: #dc2626;\n  --disp-text: #0f172a;\n  --disp-text-secondary: #64748b;\n  --disp-border: #e2e8f0;\n  --disp-bg: #fff;\n  --disp-bg-secondary: #f8fafc;\n  --disp-font-sans: 'DM Sans', sans-serif;\n  --disp-font-mono: 'DM Mono', monospace;\n\n  --serie-1: #3b82f6;\n  --serie-2: #8b5cf6;\n  --serie-3: #ec4899;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.disp-fade-in {\n  animation: fadeIn 0.4s ease-out forwards;\n}\n\n.disp-fade-in-delay-1 {\n  animation: fadeIn 0.4s ease-out 0.1s forwards;\n  opacity: 0;\n}\n\n.disp-fade-in-delay-2 {\n  animation: fadeIn 0.4s ease-out 0.2s forwards;\n  opacity: 0;\n}\n\n/* Base layout */\n.disp-container {\n  font-family: var(--disp-font-sans);\n  background-color: var(--disp-bg-secondary);\n  color: var(--disp-text);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Header */\n.disp-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 24px;\n  background-color: var(--disp-bg);\n  border-bottom: 1px solid var(--disp-border);\n  z-index: 10;\n}\n\n.disp-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.disp-btn-primary {\n  background-color: var(--disp-primary);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 20px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  box-shadow: 0 2px 4px rgba(26, 86, 219, 0.1);\n}\n\n.disp-btn-primary:hover {\n  background-color: var(--disp-primary-dark);\n  box-shadow: 0 4px 6px -1px rgba(26, 86, 219, 0.2);\n  transform: translateY(-1px);\n}\n\n/* Main Layout */\n.disp-main-layout {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n/* Sidebar */\n.disp-sidebar {\n  width: 180px;\n  min-width: 180px;\n  background-color: var(--disp-bg);\n  border-right: 1px solid var(--disp-border);\n  padding: 20px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  overflow-y: auto;\n}\n\n.disp-sidebar-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--disp-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding: 0 8px;\n  margin-bottom: 8px;\n}\n\n.disp-metric-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.disp-metric-item:hover {\n  background-color: var(--disp-bg-secondary);\n}\n\n.disp-metric-item input[type=\"radio\"] {\n  accent-color: var(--disp-primary);\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  margin: 0;\n}\n\n.disp-metric-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--disp-text);\n}\n\n/* Content Area */\n.disp-content {\n  flex: 1;\n  padding: 24px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Filters Section */\n.disp-filters-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.disp-filters-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.disp-btn-add {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background-color: var(--disp-primary);\n  color: white;\n  border: none;\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(26, 86, 219, 0.25);\n  line-height: 1;\n}\n\n.disp-btn-add:hover {\n  background-color: var(--disp-primary-dark);\n  transform: scale(1.05);\n}\n\n/* Grid Table for Series */\n.disp-grid-table {\n  background-color: var(--disp-bg);\n  border-radius: 12px;\n  border: 1px solid var(--disp-border);\n  overflow: visible;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.disp-grid-header {\n  display: grid;\n  grid-template-columns: 100px minmax(140px, 1fr) minmax(160px, 1.2fr) minmax(140px, 1fr) minmax(140px, 1fr) 80px;\n  gap: 16px;\n  padding: 12px 20px;\n  background-color: var(--disp-primary-dark);\n  align-items: center;\n  border-top-left-radius: 11px;\n  border-top-right-radius: 11px;\n}\n\n.disp-grid-header > div {\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  overflow: visible;\n}\n\n.disp-grid-row {\n  display: grid;\n  grid-template-columns: 100px minmax(140px, 1fr) minmax(160px, 1.2fr) minmax(140px, 1fr) minmax(140px, 1fr) 80px;\n  gap: 16px;\n  padding: 12px 20px;\n  align-items: center;\n  border-bottom: 1px solid var(--disp-border);\n  transition: background-color 0.2s;\n  overflow: visible;\n}\n\n.disp-menu-search-container {\n  grid-column: span 4;\n  width: 100%;\n  min-width: 0;\n}\n\n.compact-menu-disp {\n  display: grid !important;\n  grid-template-columns: minmax(140px, 1fr) minmax(160px, 1.2fr) minmax(140px, 1fr) minmax(140px, 1fr) !important;\n  gap: 16px !important;\n  width: 100% !important;\n  min-width: 0 !important;\n}\n\n.compact-option-large {\n  width: 100%;\n  min-width: 0;\n  position: relative;\n}\n\n.compact-option-large .user-box-disp,\n.compact-option-large .react-select-container-admin-gs,\n.compact-option-large .react-select-admin-gs__control {\n  white-space: nowrap !important;\n  flex-wrap: nowrap !important;\n  min-width: 0 !important;\n  width: 100% !important;\n}\n\n.user-box-disp {\n  width: 100%;\n}\n\n.disp-grid-row:hover {\n  background-color: var(--disp-bg-secondary);\n}\n\n.disp-grid-row:nth-child(even) {\n  background-color: #fafafa;\n}\n\n.disp-grid-row:nth-child(even):hover {\n  background-color: #f1f5f9;\n}\n\n.disp-grid-row:last-child {\n  border-bottom: none;\n}\n\n.disp-serie-name {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  overflow: visible;\n\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.disp-bullet {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.disp-menu-search-container {\n  grid-column: span 4;\n  width: 100%;\n}\n\n.disp-menu-search-container>div {\n  display: grid !important;\n  grid-template-columns: 1fr 1fr 1fr 1fr !important;\n  gap: 12px !important;\n  width: 100% !important;\n}\n\n.disp-btn-icon {\n  background: transparent;\n  border: 1px solid transparent;\n  color: var(--disp-text-secondary);\n  border-radius: 6px;\n  padding: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.disp-btn-icon:hover {\n  background-color: var(--disp-bg-secondary);\n  color: var(--disp-text);\n  border-color: var(--disp-border);\n}\n\n.disp-btn-icon.danger {\n  color: var(--disp-error);\n}\n\n.disp-btn-icon.danger:hover {\n  background-color: #fef2f2;\n  border-color: #fecaca;\n  color: var(--disp-error);\n}\n\n/* Card containing chart */\n.disp-card {\n  background-color: var(--disp-bg);\n  border-radius: 12px;\n  border: 1px solid var(--disp-border);\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n}\n\n.disp-card-header {\n  padding: 12px 20px;\n  border-bottom: 1px solid var(--disp-border);\n  background-color: var(--disp-bg-secondary);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 12px 12px 0 0;\n  min-height: 56px;\n}\n\n.disp-checkbox-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  padding: 6px 12px;\n  border-radius: 8px;\n  transition: background-color 0.2s;\n  border: 1px solid var(--disp-border);\n  background-color: var(--disp-bg);\n}\n\n.disp-checkbox-wrapper:hover {\n  background-color: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n.disp-checkbox-wrapper input[type=\"checkbox\"] {\n  accent-color: var(--disp-primary);\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  margin: 0;\n}\n\n.disp-checkbox-wrapper span {\n  font-size: 13px;\n  font-weight: 500;\n  user-select: none;\n}\n\n.disp-chart-area {\n  height: 400px;\n  padding: 20px;\n  position: relative;\n}\n\n.disp-chart-footer {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  padding: 20px;\n  border-top: 1px solid var(--disp-border);\n  background-color: #fafafa;\n  border-radius: 0 0 12px 12px;\n}\n\n.disp-stat-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.disp-stat-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--disp-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.disp-stat-values {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.disp-stat-value {\n  font-size: 14px;\n  font-family: var(--disp-font-mono);\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.disp-mono {\n  font-family: var(--disp-font-mono);\n}\n\n/* Results Table */\n.disp-results-table {\n  background-color: var(--disp-bg);\n  border-radius: 12px;\n  border: 1px solid var(--disp-border);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.disp-results-header {\n  display: grid;\n  grid-template-columns: 1.5fr 1.5fr 1fr 1fr 1fr;\n  gap: 16px;\n  padding: 14px 20px;\n  background-color: var(--disp-primary-dark);\n  align-items: center;\n}\n\n.disp-results-header>div {\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.disp-results-row {\n  display: grid;\n  grid-template-columns: 1.5fr 1.5fr 1fr 1fr 1fr;\n  gap: 16px;\n  padding: 14px 20px;\n  align-items: center;\n  border-bottom: 1px solid var(--disp-border);\n  transition: background-color 0.2s;\n}\n\n.disp-results-row:hover {\n  background-color: var(--disp-bg-secondary);\n}\n\n.disp-results-row:last-child {\n  border-bottom: none;\n}\n\n.disp-results-val {\n  font-family: var(--disp-font-mono);\n  font-size: 14px;\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
